{
  "aboutDeviceControls": "À propos des commandes de l'appareil",
  "actionLabel": "Action: ",
  "adminUser": "Utilisateur administrateur",
  "automation": "Automation",
  "command": "Commande",
  "conditionLabel": "Condition: ",
  "confirmDeviceActionCannotCancelWarning": "Cette action ne peut pas être annulée.",
  "confirmDeviceActionIAcceptText": "J'accepte la responsabilité du résultat de cette action",
  "confirmDeviceActionSuccessToast": "Demande envoyée à l'appareil",
  "confirmDeviceActionSuccessToastWithDeviceName": "Requête envoyée à l'appareil {{deviceName}}",
  "confirmDeviceActionWarningDescription": "Le contrôle manuel d'un circuit peut avoir des conséquences dangereuses. En effectuant cette action, vous acceptez l'entière responsabilité de tout préjudice ou dommage pouvant en résulter.",
  "confirmationRequired": "Confirmation requise",
  "controlPanelHelpContent": "Vous pouvez envoyer des commandes pour contrôler directement le commutateur (également appelé relais) de votre appareil. Ces commandes peuvent avoir des effets différents en fonction de la manière dont vous avez installé votre appareil et du type d'installation de votre équipement.\n\nPour utiliser ces commandes, vous devez avoir l'autorisation de contrôler les appareils à distance. Si vous êtes responsable de votre ferme, vous pouvez refuser ou accorder l'accès à ces fonctionnalités à partir des paramètres du compte.",
  "controls": "Contrôles",
  "deviceActionHistoryListEmpty": "Aucun historique de commande trouvé pour cet appareil",
  "deviceActionHistoryListTitle": "Historique des actions",
  "deviceActionHistoryListHelpBodyText": "Affichez les actions précédentes effectuées sur un appareil. Cette liste comprend les actions automatisées effectuées par FarmHQ, ainsi que les actions manuelles effectuées par les utilisateurs.",
  "deviceControls": "Commandes de l'appareil",
  "result": "Résultat",
  "system": "Système",
  "time": "Temps",
  "triggeredBy": "Déclenché par",
  "turnWaterOff": "Couper l'eau",
  "turnWaterOn": "Ouvrir l'eau",
  "unknownAction": "Action inconnue",
  "warning": "Avertissement"
}
